let agentFieldNode = document.querySelector( `#realpress_agent_content input[type=radio]:checked` );
const enableAgentNode = document.querySelector( `#realpress_agent_content .realpress-checkbox-content input[type=checkbox]` );
const rowNodes = document.querySelectorAll( '#realpress_agent_content .realpress-row' );

const realpressAgent = () => {
	handleEnableDisable( enableAgentNode );
	enableAgentNode.addEventListener( 'change', function( event ) {
		handleEnableDisable( this );
	} );

	const radioBtnNodes = document.querySelectorAll( `#realpress_agent_content input[type=radio]` );
	for ( let i = 0; i < radioBtnNodes.length; i++ ) {
		radioBtnNodes[ i ].addEventListener( 'click', function() {
			handleSelectField( this );
		} );
	}
};
const handleSelectField = ( agentFieldNode ) => {
	if ( agentFieldNode.value === 'agent' ) {
		rowNodes[ 1 ].style.display = 'block';
	} else {
		rowNodes[ 1 ].style.display = 'none';
	}

	if ( agentFieldNode.value === 'show_custom_field' ) {
		rowNodes[ 2 ].style.display = 'block';
	} else {
		rowNodes[ 2 ].style.display = 'none';
	}
};

const handleEnableDisable = ( enableAgentNode ) => {
	if ( enableAgentNode.checked ) {
		rowNodes[ 0 ].querySelector( '.realpress-radio-button-wrapper' ).style.display = 'block';
		agentFieldNode = document.querySelector( `#realpress_agent_content input[type=radio]:checked` );
		handleSelectField( agentFieldNode );
	} else {
		rowNodes[ 0 ].querySelector( '.realpress-radio-button-wrapper' ).style.display = 'none';
		rowNodes[ 1 ].style.display = 'none';
		rowNodes[ 2 ].style.display = 'none';
	}
};

export default realpressAgent;
